var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgZeroSlippage = function SvgZeroSlippage(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 30h5.207a2 2 0 0 0 1.824-1.18l2.192-4.87c.7-1.556 2.9-1.578 3.631-.036l5.755 12.15a2 2 0 0 0 3.386.37l4.405-5.662A2 2 0 0 1 42.478 30H46",
    stroke: "#C9975A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_264_12782",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 56,
    height: 56
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 2C14.54 2 2 14.54 2 30s12.54 28 28 28 28-12.54 28-28S45.46 2 30 2ZM8.635 30C8.635 18.19 18.19 8.635 30 8.635c4.71 0 9.024 1.526 12.54 4.114L12.682 42.607C10.162 39.024 8.635 34.71 8.635 30ZM30 51.365c-4.71 0-9.024-1.526-12.54-4.114l29.858-29.858a21.182 21.182 0 0 1 4.113 12.54C51.365 41.745 41.744 51.366 30 51.366Z",
    fill: "url(#paint0_linear_264_12782)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_264_12782)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_264_12782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 2C14.54 2 2 14.54 2 30s12.54 28 28 28 28-12.54 28-28S45.46 2 30 2ZM8.635 30C8.635 18.19 18.19 8.635 30 8.635c4.71 0 9.024 1.526 12.54 4.114L12.682 42.607C10.162 39.024 8.635 34.71 8.635 30ZM30 51.365c-4.71 0-9.024-1.526-12.54-4.114l29.858-29.858a21.182 21.182 0 0 1 4.113 12.54C51.365 41.745 41.744 51.366 30 51.366Z",
    fill: "url(#paint1_linear_264_12782)",
    fillOpacity: 0.07
  })), /*#__PURE__*/React.createElement("path", {
    d: "m42.717 12.926.206-.206-.235-.173A21.283 21.283 0 0 0 30 8.386C18.052 8.385 8.385 18.052 8.385 30c0 4.766 1.544 9.129 4.093 12.75l.171.244.21-.21 29.858-29.858ZM17.283 47.074l-.206.206.234.172A21.283 21.283 0 0 0 30 51.615c11.883 0 21.614-9.733 21.681-21.68v-.001c0-4.7-1.544-9.13-4.162-12.689l-.172-.234-.206.206-29.858 29.857ZM2.25 30C2.25 14.678 14.678 2.25 30 2.25S57.75 14.678 57.75 30 45.322 57.75 30 57.75 2.25 45.322 2.25 30Z",
    stroke: "url(#paint2_linear_264_12782)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_264_12782)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.438,
    cy: 46.37,
    rx: 9.629,
    ry: 8.969,
    fill: "#EDA54D"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_264_12782)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.629,
    cy: -0.031,
    rx: 9.629,
    ry: 8.969,
    fill: "#95F0FB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_264_12782",
    x1: 30,
    y1: 2,
    x2: 30,
    y2: 58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1B1A",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_264_12782",
    x1: 30,
    y1: 2,
    x2: 30,
    y2: 58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1B1A",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_264_12782",
    x1: 30,
    y1: 2,
    x2: 30,
    y2: 27.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292725",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_264_12782",
    x: -4,
    y: -4,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImage",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_264_12782"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_264_12782",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_264_12782",
    x: -11.191,
    y: 11.401,
    width: 71.258,
    height: 69.938,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13,
    result: "effect1_foregroundBlur_264_12782"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_264_12782",
    x: 0,
    y: -35,
    width: 71.258,
    height: 69.938,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13,
    result: "effect1_foregroundBlur_264_12782"
  })))));
};
export default SvgZeroSlippage;